export const enUS = {
  "common.name": "Name",
  "common.establishmentName": "Establishment name",
  "common.email": "Email",
  "common.password": "Password",
  "common.country": "Country",
  "common.state": "State",
  "common.city": "City",
  "common.all": "All",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.createdAt": "Created at",
  "common.yes": "Yes",
  "common.no": "No",
  "common.add": "Add",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.view": "View",
  "common.save": "Save",
  "common.saveNow": "Save now",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.undo": "Undo",
  "common.close": "Close",
  "common.create": "Create",
  "common.update": "Update",
  "common.search": "Search",
  "common.actions": "Actions",
  "common.status": "Status",
  "common.success": "Success",
  "common.error": "Error",
  "common.loading": "Loading",
  "common.back": "Back",
  "common.continue": "Continue",
  "common.submit": "Submit",
  "common.manage": "Manage {name}",
  "common.export": "Export",
  "common.download": "Download",
  "common.title": "Title",
  "common.establishments": "Establishments",
  "common.establishmentsHelper":
    "Type at least 3 letters to search for the establishment",
  "establishmentAutocomplete.searchError":
    "Error searching for establishments. Please try again.",
  "filters.title": "Filters",
  "filters.onlyActive": "Active only",
  "filters.sort.default": "Sort",
  "filters.sort.nameAsc": "Name (A -> Z)",
  "filters.sort.nameDesc": "Name (Z -> A)",
  "filters.sort.createdAsc": "Created (Oldest)",
  "filters.sort.createdDesc": "Created (Newest)",
  "cameras.confirmTitle": "Confirm action",
  "cameras.confirmMessage": "Are you sure you want to {name}?",
  "cameras.manageDescription": "logos, music, website videos...",
  "cameras.openPreviewTooltip": "Open preview",

  "messages.saveSuccess": "Saved successfully!",
  "messages.deleteSuccess": "Deleted successfully!",
  "messages.updateSuccess": "Updated successfully!",
  "messages.createSuccess": "Created successfully!",
  "messages.loadError": "Error loading data",
  "messages.saveError": "Error saving",
  "messages.deleteError": "Error deleting",
  "messages.connectionError":
    "There was a connection problem. Please try again.",
  "messages.youtubeTokenExpired":
    "The YouTube connection has expired. Re-authorize the YouTube account in the admin panel and try again.",
  "global.generic_error": "Unexpected error. Please try again.",
  "global.saved": "Saved successfully.",
  "global.discarded": "Changes discarded.",
  "messages.serverError": "Internal server error. Please try again.",
  "messages.unsavedChanges":
    "You have unsaved changes. Do you really want to leave without saving?",
  "messages.leaveWithoutSaving": "Leave without saving",
  "messages.stayOnPage": "Keep editing",
  "errorBoundary.title": "Something went wrong",
  "errorBoundary.body": "An unexpected error occurred while loading this page. Please try again.",
  "errorBoundary.retry": "Try again",
  "messages.confirmDelete":
    "This action is irreversible. Do you want to continue anyway?",
  "messages.fillRequiredFields": "Fill in all required fields",
  "global.cancel": "Cancel",
  "global.close": "Close",
  "global.save": "Save",

  "validation.required": "{field} is required",
  "validation.emailRequired": "Email is required",
  "validation.passwordRequired": "Password is required",
  "validation.invalidEmail": "Invalid email",
  "validation.passwordMismatch": "Passwords do not match",
  "validation.passwordCriteria": "The password does not meet security criteria",

  "placeholder.enterEmail": "Enter your email",
  "placeholder.enterPassword": "Enter your password",
  "placeholder.search": "Search",
  "placeholder.searchByNameOrEmail": "Search by name or email",

  "login.welcome": "Welcome to",
  "login.adminPanel": "Admin Panel",
  "login.subtitle": "Manage your cameras, streams and subscriptions",
  "login.enterPanel": 'Enter the "Admin Panel"',
  "login.enterEmailPlaceholder": "Enter your email",
  "login.enterPasswordPlaceholder": "Enter your password",
  "login.signIn": "Sign in",
  "login.success": "Signed in successfully!",
  "login.forgotPassword": "Forgot my password",
  "login.rememberMe": "Remember me",
  "login.emailRequired": "Email is required",
  "login.passwordRequired": "Password is required",
  "login.invalidCredentials": "Incorrect email or password",
  "login.tooManyAttempts": "Too many login attempts. Wait a few minutes and try again.",
  "login.togglePasswordVisibility": "Show/hide password",

  "forgotPassword.title": "Forgot your password?",
  "forgotPassword.subtitle": "We will help you reset it quickly.",
  "forgotPassword.recover": "Recover password",
  "forgotPassword.emailPlaceholder": "Enter your email to reset the password",
  "forgotPassword.success": "Recovery email sent successfully!",
  "forgotPassword.successTo": "We sent a recovery link to {email}.",
  "forgotPassword.sendToAnotherEmail": "Send to another email",
  "forgotPassword.spamHint": "Also check your spam or trash folder.",
  "forgotPassword.error": "Internal server error. Please try again.",

  "resetPassword.title": "Reset Password",
  "resetPassword.subtitle": "Create a new secure password",
  "resetPassword.newPassword": "New Password",
  "resetPassword.confirmPassword": "Confirm Password",
  "resetPassword.newPasswordPlaceholder": "Enter your new password",
  "resetPassword.confirmPasswordPlaceholder": "Confirm your new password",
  "resetPassword.submit": "Reset Password",
  "resetPassword.backToLogin": "Back to Login",
  "resetPassword.requestNewLink": "Request a new link",
  "resetPassword.success": "Password reset successfully!",
  "resetPassword.error": "Internal server error. Please try again.",
  "resetPassword.passwordRequired": "Password is required",
  "resetPassword.confirmPasswordRequired": "Password confirmation is required",
  "resetPassword.criteriaTitle": "Security criteria:",
  "resetPassword.min": "Minimum {min} characters",
  "resetPassword.uppercase": "At least {min} uppercase letter",
  "resetPassword.lowercase": "At least {min} lowercase letter",
  "resetPassword.digits": "At least {min} number",
  "resetPassword.symbols": "At least {min} symbol (e.g.: ! @ # $ % &)",
  "resetPassword.confirm": "Passwords must match",
  "resetPassword.tokenValid": "Valid token",
  "resetPassword.checkingToken": "Checking link...",
  "resetPassword.redirectingIn": "Redirecting in {seconds}s...",

  "notFound.oops": "Oops!",
  "notFound.pageNotFound": "Page not found",
  "notFound.forbidden":
    "You don't have permission to access this page. Contact an administrator if you believe you should have access.",
  "notFound.backToHome": "Back to home",

  // Drawer / Navigation
  "drawer.dashboard": "Dashboard",
  "drawer.cameras": "Cameras",
  "drawer.liveStreams": "Live Streams",
  "drawer.subscriptions": "Subscriptions",
  "drawer.visitors": "Visitors",
  "drawer.users": "Users",
  "drawer.links": "Links",
  "drawer.youtubeAccounts": "YouTube Accounts",
  "drawer.reports": "Reports",
  "drawer.audit": "Audit",
  "drawer.help": "Help",
  "help.title": "Help",
  "help.subtitle": "Step-by-step guides for everyday processes.",
  "help.notes": "Notes",
  "drawer.more": "More",

  // Country
  "country.BR": "Brazil",
  "country.UY": "Uruguay",
  "country.PT": "Portugal",
  "country.US": "United States",
  "country.ES": "Spain",

  "appBar.editUser": "Edit User",
  "appBar.changePassword": "Change Password",
  "appBar.logout": "Logout",
  "appBar.build": "Version",
  "appBar.build.unknown": "Unknown",

  // ChangePassword
  "changePassword.title": "Change Password",
  "changePassword.currentPassword": "Current Password",
  "changePassword.currentPasswordPlaceholder": "Enter your current password",
  "changePassword.success": "Password changed successfully!",
  "changePassword.error": "Error changing password, please try again.",
  "appBar.theme.light": "Light",
  "appBar.theme.dark": "Dark",
  "appBar.role.ADMIN": "Administrator",
  "appBar.role.OWNER": "Owner",
  "appBar.role.SUPPORT": "Support",

  "systemUserForm.success": "User saved successfully!",
  "systemUserForm.error": "Error saving user.",
  "systemUserForm.searchError": "Error fetching establishments",
  "systemUserForm.create": "Create and Send Invite",
  "systemUserForm.role": "Role",
  "systemUserForm.roleHelper": "Defines the user's access level. ADMIN: full access. SUPPORT: read and management access. OWNER: access only to their own establishments.",
  "systemUserForm.inviteInfo": "An email will be sent to the user with instructions to set their password and activate the account.",
  "systemUserForm.activeHelper": "Inactive users cannot access the system.",
  "systemUserForm.establishmentsHiddenHint": "The establishments field was hidden, but your previous selection was kept — it reappears if you choose the Owner role again.",

  "userRegisterAccept.title": "Complete Registration",
  "userRegisterAccept.subtitle": "Set your password",
  "userRegisterAccept.description": "You have been invited to access the Meulance system. Set your password to activate your account.",
  "userRegisterAccept.definePassword": "Set your access password",
  "userRegisterAccept.newPassword": "New password",
  "userRegisterAccept.confirmPassword": "Confirm password",
  "userRegisterAccept.newPasswordPlaceholder": "Enter your new password",
  "userRegisterAccept.confirmPasswordPlaceholder": "Confirm your new password",
  "userRegisterAccept.submit": "Complete Registration",
  "userRegisterAccept.backToLogin": "Back to Login",
  "userRegisterAccept.success":
    "Registration completed successfully! You can log in now.",
  "userRegisterAccept.error": "Error completing registration",
  "userRegisterAccept.redirectHint": "You will be redirected to the login in a moment.",
  "userRegisterAccept.invalidToken": "Invalid or expired token",

  "genericForm.loadError": "Error loading data",
  "genericForm.fillAllRequiredFields": "Fill in all required fields",

  "genericList.rowsPerPage": "Rows per page",
  "genericList.displayedRows": "{from}-{to} of {count}",
  "genericList.moreThan": "more than {to}",

  "systemUser.title": "Users",
  "systemUser.role": "Role",
  "systemUser.add": "Add user",
  "systemUser.edit": "Edit user",
  "systemUser.delete": "Delete user",
  "systemUser.createdAt": "Created at",
  "systemUser.searchPlaceholder": "Search by name or email",
  "systemUser.sendPasswordReset": "Send password reset email",
  "systemUser.passwordResetConfirmMessage": "Send password reset email to {email}?",
  "systemUser.fetchError": "Error fetching users",
  "systemUser.deleteSuccess": "User deleted successfully",
  "systemUser.passwordResetSuccess": "Password reset email sent successfully to {email}",
  "systemUser.passwordResetError": "Error sending password reset email",
  "systemUser.yes": "Yes",
  "systemUser.no": "No",
  "systemUser.empty": "No users found.",
  "systemUser.selectHint": "Click a row to select",

  "establishmentForm.title": "Establishment",
  "establishmentForm.success": "Establishment saved successfully!",
  "establishmentForm.error": "Error saving establishment.",
  "establishmentForm.create": "Register",
  "establishmentForm.new": "New establishment",
  "establishmentForm.timezone": "Timezone",
  "establishmentForm.channels": "Cameras",
  "establishmentForm.channelsHint": "Each camera represents a court at this establishment.",
  "establishmentForm.channelsRestricted": "Only admins/support can manage cameras.",
  "establishmentForm.channelsSaveHint":
    "Camera changes save immediately when you click each row's save icon — they are not part of the form's general save.",
  "establishmentForm.addChannel": "Add camera",
  "establishmentForm.channelName": "Camera Name",
  "establishmentForm.actions": "Actions",
  "establishmentForm.confirmDeleteChannel":
    "Are you sure you want to delete this camera? The change will be saved only after saving the form.",
  "establishmentForm.private": "Private establishment",
  "establishmentForm.manageVisitors": "Manage Visitors",

  "logoEditor.title": "Logo Editor",
  "logoEditor.deleteConfirmTitle": "Delete Logo",
  "logoEditor.deleteConfirmMessage":
    "This action is irreversible. Do you want to continue anyway?",
  "logoEditor.deleteSuccess": "Logo deleted successfully!",
  "logoEditor.deleteError": "Error deleting logo.",
  "logoEditor.saveSuccess": "Logos saved successfully!",
  "logoEditor.saveError": "Error saving logos.",
  "logoEditor.loadLogosError": "Error loading logos.",
  "logoEditor.loadSnapshotError": "Error loading snapshot.",

  "upload.unsupportedFile": "Unsupported file",
  "upload.dropFiles": "Drop files here",
  "upload.acceptedFormats": "Accepted formats: PNG, JPEG, GIF",

  "logoList.addLogos": "Add logos",

  "deleteDialog.confirmMessage":
    "This action is irreversible. Do you want to continue anyway?",

  "camLayoutEditor.preserveAspectRatio":
    "Preserve aspect ratio when resizing logos",
  "camLayoutEditor.undoPosition": "Undo last position (Ctrl+Z)",

  "establishmentList.title": "Establishments",
  "establishmentList.channels": "Cameras",
  "establishmentList.createdAt": "Creation Date",
  "establishmentHashList.title": "Links",
  "establishmentHashList.createLink": "Create new link",
  "establishmentHashList.address": "Address",
  "establishmentHashList.empty": "No links registered",
  "establishmentHashList.fetchError": "Error fetching establishments",
  "establishmentHashList.deleteSuccess": "Link deleted successfully",
  "establishmentHashList.qrCode": "View QR code",
  "establishmentList.searchPlaceholder": "Search",
  "establishmentList.toggleStatus": "Enable/Disable",
  "establishmentList.toggleConfirmTitle": "Enable/Disable establishment",
  "establishmentList.toggleConfirmMessage":
    "Are you sure you want to {action} {name}?",
  "establishmentList.enable": "Enable",
  "establishmentList.disable": "Disable",
  "establishmentList.createLink": "Create Link",
  "establishmentList.selectHint": "Select an establishment to create a link",
  "establishmentList.fetchError": "Error fetching establishments",
  "establishmentList.statusUpdateSuccess": "Status updated successfully",
  "establishmentList.deleteSuccess": "Establishment deleted successfully",
  "establishmentList.empty": "No establishments found.",

  "cameras.title": "Cameras",
  "cameras.fetchError": "Error fetching cameras",
  "cameras.noCameras": "No cameras registered",
  "cameras.noCamerasHintOperator": "Click \"Add\" above to register your first establishment and cameras.",
  "cameras.noCamerasHint": "No establishment with cameras was found for your user.",
  "cameras.replaysLabel": "Active camera",
  "cameras.playPreview": "Start live preview",
  "cameras.pausePreview": "Pause live preview",
  "cameras.streamUnavailable": "Live stream unavailable right now",
  "cameras.streamReplaced": "The preview was interrupted because someone else opened a camera. Please try again.",
  "cameras.offlineNoPreview": "Camera offline",
  "cameras.onlineFilterAria": "Filter by connection status",
  "cameras.onlineFilterAll": "All",
  "cameras.onlineCount": "{online}/{total} online",
  "cameras.noCamerasForOnlineFilter": "No cameras found for this filter.",
  "cameras.offlineSince": "Offline since {date}",
  "cameras.streamFallbackSnapshot":
    "Showing the most recent snapshot when available.",
  "cameras.openLegacyPreview": "Open live camera URL",
  "cameras.legacyPreviewUnavailable":
    "Could not resolve the legacy preview URL for this camera.",
  "cameras.toggleTooltip": "Enable/Disable",
  "cameras.toggleTooltipAdmin": "Admin only",
  "cameras.toggleSuccess": "Status updated successfully",
  "cameras.searchPlaceholder": "Search by camera or establishment",
  "cameras.channelCreatedAt": "Camera created on {date}",
  "cameras.toggleConfirmTitle": "Enable/Disable court",
  "cameras.toggleConfirmMessage":
    "Are you sure you want to {action} the court {name}?",
  "cameras.enable": "Enable",
  "cameras.disable": "Disable",

  "cameras.channelUpdatedAt": "Camera updated on {date}",
  "cameras.deleteSuccess": "Court deleted successfully",
  "cameras.deleteDialog.title": "Confirm deletion",
  "cameras.deleteDialog.titleEstablishment": "Delete establishment",
  "cameras.deleteDialog.titleChannel": "Delete camera",
  "cameras.deleteDialog.titleDevice": "Delete device",
  "cameras.deleteDialog.messageEstablishment": "Are you sure you want to delete the establishment \"{name}\"? All channels and devices will be removed.",
  "cameras.deleteDialog.messageChannel": "Are you sure you want to delete the camera \"{name}\"?",
  "cameras.deleteDialog.messageDevice": "Are you sure you want to delete the device \"{name}\"?",
  "cameras.deleteDialog.message":
    "You are about to delete {name}. This action cannot be undone.",
  "cameras.deleteDialog.warning":
    "Once confirmed, the removal will be permanent and irreversible.",
  "cameras.deleteDialog.checkbox":
    "I confirm I want to delete this and understand this action is irreversible.",
  "cameras.deleteDialog.confirm": "Yes, delete",
  "deletionPreview.descriptionEstablishment":
    "This action is permanent and will also delete everything that belongs to establishment \"{name}\":",
  "deletionPreview.descriptionChannel":
    "This action is permanent and will also delete everything that belongs to camera \"{name}\":",
  "deletionPreview.rowChannels": "Channels",
  "deletionPreview.rowVideos": "Videos",
  "deletionPreview.rowLogos": "Logos",
  "deletionPreview.rowFavorites": "Visitor favorites",
  "deletionPreview.rowSavedVideos": "Videos saved by visitors",
  "deletionPreview.typeToConfirm": "To confirm, type \"{name}\" below:",
  "deletionPreview.loadError": "Could not load what will be deleted. Please try again.",
  "deletionPreview.confirm": "Permanently delete",
  "establishment.paymentBlocked.title": "Access blocked due to overdue payment",
  "establishment.paymentBlocked.message": "This club's subscription has a pending payment. Contact the billing team to settle it and unlock access again.",
  "cameras.details.title": "Camera Details",
  "cameras.details.tabDetails": "Details",
  "cameras.details.subtitle": "Edit the camera name and access settings",
  "cameras.details.cameraLabel": "Camera",
  "cameras.details.saveSuccess": "Name updated successfully",
  "cameras.details.saveError": "Error updating name",
  "cameras.details.videos": "Site Videos",
  "cameras.details.logos": "Logos and Music",
  "cameras.details.privateCourt": "Private Court",
  "cameraLogos.title": "Logos and Music",
  "cameraLogos.divergenceWarning":
    "This court's cameras have different watermarks. Choose one configuration to use on all of them.",
  "cameraLogos.fileTooLarge":
    "One or more files exceed the 5MB limit and were not added.",
  "cameraLogos.logos": "Logos",
  "cameraLogos.musicHint": "Choose a track and save it for this camera.",
  "cameraLogos.defaultLogoLabel": "Default Meu Lance logo",
  "cameraLogos.defaultLogoHint":
    "Control whether the default Meu Lance logo shows in the top-left corner.",
  "cameraLogos.defaultLogoPreviewHint":
    "The preview keeps the real transmission ratio. On a 1920 px-wide base, the default logo occupies 276x67 px, 60px from the left and 50px from the top.",
  "cameraLogos.defaultLogoSaved": "Default logo updated",
  "cameraLogos.defaultLogoSaveError": "Error updating default logo",
  "cameraLogos.music": "Music",
  "cameraLogos.musicSaved": "Music saved successfully",
  "cameraLogos.musicSaveError": "Error saving music",
  "cameraLogos.noMusic": "No music",
  "cameraLogos.positionTitle": "Logo positioning",
  "cameraLogos.positionSubtitle": "Drag and resize over the base image",
  "cameraLogos.libraryTitle": "Logo library",
  "cameraLogos.librarySubtitle": "Upload, remove and organize your logos",
  "logoEditor.loadingSnapshot": "Loading snapshot...",
  "cameraPrivate.title": "Private Access",
  "cameraPrivate.description":
    "Enable private access and set a password to restrict access to this camera.",
  "cameraPrivate.enable": "Enable private access",
  "cameraPrivate.password": "Password",
  "cameraPrivate.passwordSetPlaceholder": "Password set — leave blank to keep it",
  "cameraPrivate.passwordSetHelper": "A password is already set. Type a new one only if you want to replace it.",
  "cameraPrivate.saveSuccess": "Settings saved successfully",
  "cameraPrivate.authorizedTitle": "Authorized users",
  "cameraPrivate.authorizedDescription":
    "Only users listed here will be able to watch private videos.",
  "cameraPrivate.manageAuthorized": "Manage authorized users",
  "cameraPrivate.passwordMode": "Private with password",
  "cameraPrivate.authorizedMode": "Private with authorized users",
  "cameraPrivate.mutuallyExclusive":
    "You can enable only one method at a time. Turning one on disables the other.",
  "cameraPrivate.passwordHint":
    "Set the password to allow access when this mode is active.",
  "cameraPrivate.save": "Save privacy",
  "cameraPrivate.saveHint":
    "Saves the current mode (password or authorized users).",
  "createLinkDialog.title": "Create link",
  "createLinkDialog.createButton": "Create link",
  "createLinkDialog.success": "Link created successfully",
  "createLinkDialog.error": "Error creating link",
  "createLinkDialog.successTitle": "Link created successfully",
  "createLinkDialog.linkLabel": "Link",
  "createLinkDialog.viewLinks": "View links",
  "createLinkDialog.qrCode": "View QR code",
  "qrCodeDialog.title": "QR code",
  "qrCodeDialog.alt": "Link QR code",
  "qrCodeDialog.error": "Could not generate the QR code",
  "qrCodeDialog.download": "Download PNG",
  "qrCodeDialog.downloadError": "Could not download. Press and hold the image to save it.",

  "establishmentList.confirmDeleteTitle": "Delete establishment",
  "establishmentList.confirmDeleteMessage":
    "Are you sure you want to delete {name}? This action will delete all courts.",
  "cameras.confirmDeleteTitle": "Delete court",
  "cameras.confirmDeleteMessage":
    "Are you sure you want to delete the court {name}?",
  "video.delete_success": "Video deleted successfully",
  "video.delete_error": "Couldn't delete the video. Check your connection and try again.",
  "video.restore_success": "Video restored successfully",
  "video.restore_error": "Couldn't restore the video. Check your connection and try again.",
  "cameraVideos.title": "Site Videos",
  "cameraVideos.filters.date": "Date",
  "cameraVideos.filters.hour": "Time",
  "cameraVideos.filters.allDates": "All dates",
  "cameraVideos.filters.allHours": "All hours",
  "cameraVideos.filters.today": "Today",
  "cameraVideos.filters.status": "Status",
  "cameraVideos.filters.active": "Active",
  "cameraVideos.filters.inactive": "Inactive",
  "cameraVideos.empty": "No videos found for the selected filters",
  "cameraVideos.emptyToday": "No videos yet today.",
  "cameraVideos.confirmDeleteTitle": "Delete video",
  "cameraVideos.confirmDeleteMessage":
    "Are you sure you want to delete the video from {name}?",
  "cameraVideos.deleteVideo": "Delete video",
  "cameraVideos.thumbnailAlt": "Video thumbnail",
  "cameraVideos.toggleStatus": "Enable/Disable video",
  "cameraVideos.confirmToggleTitle": "Enable/Disable video",
  "cameraVideos.confirmToggleMessage":
    "Are you sure you want to {action} the video from {name}?",
  "cameraVideos.enable": "enable",
  "cameraVideos.disable": "disable",
  "cameraVideos.tabProcessed": "Processed",
  "cameraVideos.tabPending": "Pending",
  "cameraVideos.pendingWarning":
    "Only videos uploaded in the last 48 hours can be recovered. Older videos have already been automatically removed from source storage.",
  "cameraVideos.pendingEmpty": "No pending videos found.",
  "cameraVideos.pendingLoadError": "Could not load pending videos.",
  "cameraVideos.pendingName": "File",
  "cameraVideos.pendingLastModified": "Uploaded at",
  "cameraVideos.reprocessSelected": "Reprocess selected",
  "cameraVideos.reprocessSelectedCount": "Reprocess {count} selected",
  "cameraVideos.confirmReprocessTitle": "Reprocess videos",
  "cameraVideos.confirmReprocessMessage":
    "Are you sure you want to reprocess {count} video(s)?",
  "cameraVideos.reprocessSuccess": "Reprocessing triggered successfully.",
  "cameraVideos.reprocessPartialError": "{count} video(s) failed to reprocess.",
  "cameraVideos.reprocessError": "Could not reprocess the selected videos.",
  "cameraVideos.pendingRefresh": "Refresh list",
  "cameraVideos.pendingStatus": "Status",
  "cameraVideos.pendingStatusTriggered": "Reprocessing triggered",
  "cameraVideos.pendingStatusError": "Failed to trigger",

  "visitorsList.title": "Visitors",
  "visitorsList.selectedCount": "{count} selected",
  "visitorsList.selectAll": "Select all",
  "visitorsList.deleteManyConfirm": "Are you sure you want to delete the {count} selected visitors?",
  "visitorsList.phone": "Phone",
  "visitorsList.establishment": "Establishment",
  "visitorsList.createdAt": "Registration Date",
  "visitorsList.searchPlaceholder": "Search",
  "visitorsList.searchMinChars": "Type at least 3 characters",
  "visitorsList.exportAllHint": "Exports the full visitor list (ignores the table selection)",
  "visitorsList.deleteProgress": "Deleting {done} of {total}...",
  "visitorsList.deleteSuccess": "User deleted successfully",
  "visitorsList.enterEmail": "Enter an email",
  "visitorsList.exportSuccess": "Request submitted",
  "visitorsList.empty": "No visitors found.",

  "exportVisitorsDialog.confirmMessage": "Do you want to export all contacts?",
  "exportVisitorsDialog.explanation": "You will receive a file with the full visitor list by email in a few minutes.",
  "exportVisitorsDialog.emailPlaceholder": "Enter your email",

  "establishmentVisitor.title": "Allowed Visitors",
  "establishmentVisitor.createdAt": "Creation Date",
  "establishmentVisitor.emailPlaceholder": "email1@example.com",
  "establishmentVisitor.emailHelper":
    "Enter the email to check the association or add",
  "establishmentVisitor.notFoundAddHint":
    "No visitor found with this email. Click Add to register it.",
  "establishmentVisitor.modeSearch": "Searching visitor",
  "establishmentVisitor.modeAdd": "No results — add new visitor",
  "establishmentVisitor.selectedCount": "{count} selected",
  "establishmentVisitor.deleteSelected": "Delete selected",
  "establishmentVisitor.empty": "No visitors found.",
  "establishmentVisitor.loadError": "Error loading allowed visitors",
  "establishmentVisitor.addSuccess": "Email added successfully",
  "establishmentVisitor.addError": "Error adding emails",
  "establishmentVisitor.addEmailNotFound": "{email} doesn't have a visitor account yet — access was not granted. Ask them to sign up and try again.",
  "establishmentVisitor.deleteConfirm":
    "Confirm deletion of the following emails?",
  "establishmentVisitor.deleteSuccess": "Visitors removed successfully",
  "establishmentVisitor.deleteError": "Error removing visitors",

  "dashboard.noCameras": "No cameras found.",
  "dashboard.videoViews": "Video Views",
  "dashboard.videoDownloads": "Video Downloads",
  "dashboard.videos": "Generated Videos",
  "dashboard.adminTitle": "Control Panel",
  "dashboard.ownerProfileTitle": "Owner Profile",
  "dashboard.sectionOperational": "Camera Status",
  "dashboard.sectionMetrics": "Audience Metrics",
  "dashboard.sectionLives": "Streams",
  "dashboard.sectionAlerts": "Alerts",
  "dashboard.noLivesToShow": "No streams to show.",
  "dashboard.noAlerts": "No alerts right now.",
  "dashboard.alertCamerasOffline": "{count} camera(s) offline. Tap to check.",
  "dashboard.alertYoutubeReconnect": "Your YouTube connection needs to be renewed. Tap to reconnect.",
  "dashboard.alertPaymentPending": "{count} stream(s) with pending payment. Tap to view.",
  "dashboard.quickActionCreateLive": "New stream",
  "dashboard.quickActionManageCameras": "Manage cameras",
  "dashboard.quickActionConfigureLogos": "Configure logos",
  "dashboard.quickActionConnectYoutube": "Connect YouTube",
  "dashboard.quickActionScoreboard": "Open scoreboard",
  "dashboard.filtersLabel": "Filters",
  "dashboard.stateFilterLabel": "State",
  "dashboard.cityFilterLabel": "City",
  "dashboard.projectedImpressions": "Projected Impressions",
  "dashboard.cameraStatusTitle": "Camera Status",
  "dashboard.cameraOnline": "Online",
  "dashboard.cameraOffline": "Offline",
  "dashboard.cameraName": "Name",
  "dashboard.cameraStatusColumn": "Camera Status",
  "dashboard.cameraLastEvent": "Last Event",
  "dashboard.cameraLastCommunication": "Last Communication",
  "dashboard.cameraLastCheck": "Last Check",
  "dashboard.cameraSdStatus": "SD Card Status",
  "dashboard.cameraButtonStatus": "Button Status",
  "dashboard.buttonOk": "OK",
  "dashboard.buttonNoShort": "No short",
  "dashboard.buttonOffline": "Offline",
  "dashboard.buttonNotConfigured": "Not configured",
  "dashboard.buttonHealthBadTitle": "Button issue",
  "dashboard.buttonHealthOkHint": "Button working normally, no short circuit detected.",
  "dashboard.buttonHealthReasonVeryLong": "Video over 5 minutes",
  "dashboard.buttonHealthReasonThreeLong":
    "3 consecutive videos over 2 minutes",
  "dashboard.buttonShortCircuit": "Short circuit",
  "dashboard.establishmentLabel": "Establishment",
  "dashboard.establishmentLabelCameras": "Establishment (cameras)",
  "dashboard.establishmentLabelMetrics": "Establishment (metrics)",
  "dashboard.formatHelper": "Applies to all charts below",
  "dashboard.sdFormat": "Format SD card",
  "dashboard.sdResetHint": "Reset card",
  "dashboard.sdFormatConfirm":
    "Do you want to format this camera's SD card? This may take a few minutes.",
  "dashboard.sdFormatSuccess": "Format requested.",
  "dashboard.sdFormatError": "Error requesting SD card format.",
  "datePicker.month": "Month",
  "datePicker.year": "Year",
  "datePicker.clear": "Clear",
  "datePicker.today": "Today",
  "timePicker.hour": "Hour",
  "timePicker.minute": "Minute",
  "timePicker.now": "Now",
  "timePicker.period": "Period",
  "timePicker.am": "AM",
  "timePicker.pm": "PM",
  "dashboard.sdOk": "OK",
  "dashboard.sdError": "Error",
  "dashboard.statusUnknown": "N/A",
  "dashboard.daysWithoutEvent": "+{days} days without event",
  "dashboard.loadError": "Error loading dashboard data",
  "dashboard.cameraStatusPartialError": "Error loading status for {count} establishment(s).",
  "dashboard.cameraStatusError": "Error loading camera status.",
  "dashboard.metricsRestricted": "Audience metrics are available to administrators, support and owners.",

  // Live Streams
  "liveStreams.title": "Live Streams",
  "liveStreams.subtitle": "{place}",
  "liveStreams.subtitleEmpty": "Select an establishment",
  "liveStreams.tabs.schedule": "Schedule",
  "liveStreams.newLive": "New live",
  "liveStreams.stepWhereWhen": "Where and when",
  "liveStreams.stepWhere": "Where",
  "liveStreams.stepConfiguration": "Configuration",
  "liveStreams.stepAudioReview": "Audio and review",
  "liveStreams.reviewTitle": "Live summary",
  "liveStreams.reviewSchedule": "Date/Time:",
  "liveStreams.tabs.lives": "Transmission History",
  "liveStreams.tabs.playlists": "Playlists",
  "liveStreams.tabs.media": "Media",
  "youtubeConnection.title": "YouTube Connection",
  "youtubeConnection.subtitle": "Connect your account to YouTube.",
  "youtubeConnection.prerequisitesAria": "YouTube subscriber requirement for live streaming",
  "youtubeConnection.prerequisitesInfo":
    "YouTube usually requires at least 50 subscribers on your channel to enable live streaming. Check YouTube Help in case the rules change.",
  "youtubeConnection.connected": "Connected",
  "youtubeConnection.disconnected": "Disconnected",
  "youtubeConnection.requiresReconnect": "Reconnection needed",
  "youtubeConnection.renewalError": "Temporary renewal failure",
  "youtubeConnection.lastSyncedAt": "Last synced: {date}",
  "youtubeConnection.reconnectPromptTitle": "Your YouTube connection needs to be renewed",
  "youtubeConnection.reconnectPromptMessage":
    "Your YouTube account connection has expired. Until it is renewed, new streams may fail or be unavailable. Do you want to reconnect now?",
  "youtubeConnection.reconnectPromptCta": "Reconnect now",
  "youtubeConnection.reconnectPromptLater": "Remind me later",
  "youtubeConnection.connect": "Connect account",
  "youtubeConnection.renewOAuth": "Renew connection",
  "youtubeConnection.refreshConnection": "Refresh connection",
  "youtubeConnection.reconnect": "Reconnect account",
  "youtubeConnection.disconnect": "Disconnect",
  "youtubeConnection.support": "Contact support",
  "youtubeConnection.supportWhatsappMessage":
    "Hi! I need help with the YouTube connection in Meu Lance.",
  "youtubeConnection.blockingWarning":
    "Connect your YouTube account to schedule live streams.",
  "youtubeConnection.disconnectNotice": "YouTube account disconnected.",
  "youtubeConnection.disconnectConfirmTitle": "Disconnect your YouTube account?",
  "youtubeConnection.disconnectConfirmBody":
    "You will need to connect your account again to schedule and manage broadcasts from the app.",
  "youtubeAdminAccounts.title": "YouTube Accounts",
  "youtubeAdminAccounts.column.channel": "Channel",
  "youtubeAdminAccounts.column.scheduleLimit": "Schedule limit",
  "youtubeAdminAccounts.column.lastSyncedAt": "Last synced",
  "youtubeAdminAccounts.status.connected": "Connected",
  "youtubeAdminAccounts.status.disconnected": "Disconnected",
  "youtubeAdminAccounts.status.requiresReconnect": "Reconnection required",
  "youtubeAdminAccounts.status.renewalError": "Temporary renewal failure",
  "youtubeAdminAccounts.connect": "Connect",
  "youtubeAdminAccounts.unlink": "Unlink",
  "youtubeAdminAccounts.ownerManagedChip": "Owner",
  "youtubeAdminAccounts.empty": "No accounts registered.",
  "youtubeAdminAccounts.createTitle": "New YouTube account",
  "youtubeAdminAccounts.editTitle": "Edit YouTube account",
  "youtubeAdminAccounts.form.name": "Name",
  "youtubeAdminAccounts.form.scheduleLimit": "Schedule limit",
  "youtubeAdminAccounts.form.active": "Active",
  "youtubeAdminAccounts.createSuccess": "Account created. Click \"Connect\" to link it to Google.",
  "youtubeAdminAccounts.updateSuccess": "Account updated.",
  "youtubeAdminAccounts.unlinkSuccess": "Account unlinked from Google.",
  "youtubeAdminAccounts.deleteSuccess": "Account removed.",
  "youtubeAdminAccounts.unlinkConfirmTitle": "Unlink this account from Google?",
  "youtubeAdminAccounts.unlinkConfirmMessage":
    "The account \"{name}\" will stop streaming until someone connects it again.",
  "youtubeAdminAccounts.deleteConfirmTitle": "Delete this account?",
  "youtubeAdminAccounts.deleteConfirmMessage":
    "The account \"{name}\" will be permanently removed. This action cannot be undone.",
  "youtubeAdminAccounts.deactivateConfirmTitle": "Deactivate this account?",
  "youtubeAdminAccounts.deactivateConfirmMessage":
    "The account \"{name}\" will stop being usable for new streams (currently active schedules: {count}).",
  "liveDetails.noYoutubePoolAccountAvailable":
    "No pool YouTube account is currently active and connected. Connect or reactivate one before scheduling.",
  "liveStreams.ownerScheduledNoticeTitle": "Stream scheduled successfully",
  "liveStreams.ownerScheduledNoticeBody":
    "Now just wait for the stream to start. You can review the details on this screen and still edit anything you need.",
  "liveStreams.filterDescription": "Filter by description",
  "liveStreams.filterDevice": "Filter by device",
  "liveStreams.filterEstablishment": "Filter by establishment",
  "liveStreams.filterHistoryStatus": "Filter by status",
  "liveStreams.historyStatusWaiting": "Scheduled",
  "liveStreams.historyStatusCompleted": "Completed",
  "liveStreams.filterAll": "All",
  "liveStreams.youtubeAccount": "YouTube account",
  "liveStreams.youtubeAccountPlaceholder": "Select the YouTube account",
  "liveStreams.youtubeAccountOwn": "My account (connected)",
  "liveStreams.scheduleAdminOnly":
    "Date and time can no longer be changed: the stream has already finished.",
  "liveStreams.ownerConfirmNotice":
    "By confirming, you authorize the charge to run this broadcast. Date and time can no longer be changed afterward.",
  "liveStreams.ownerScheduleConfirmBody":
    "Do you want to confirm scheduling for {place} - {court} on {date} at {time}, with a duration of {duration}?",
  "liveStreams.ownerScheduleSummary":
    "Schedule: {place} - {court} on {date} at {time}, with a duration of {duration}.",
  "liveStreams.ownerScheduleFieldPlaceCourt": "Establishment/Court:",
  "liveStreams.ownerScheduleFieldTime": "Time:",
  "liveStreams.ownerScheduleFieldDuration": "Duration:",
  "liveStreams.upcomingTitle": "Upcoming LIVE status changes",
  "liveStreams.name": "Name",
  "liveStreams.playlist": "Playlist",
  "liveStreams.period.title": "New period broadcast",
  "liveStreams.period.startDate": "Start date",
  "liveStreams.period.endDate": "End date",
  "liveStreams.period.dailyStartTime": "Start time",
  "liveStreams.period.dailyEndTime": "End time",
  "liveStreams.period.dailyTimeInvalid": "End time must be after the start time.",
  "liveStreams.period.preview": "Preview summary",
  "liveStreams.period.confirm": "Create broadcast",
  "liveStreams.period.previewLoading": "Calculating summary...",
  "liveStreams.period.daysCount": "{count, plural, one {# broadcast day} other {# broadcast days}}",
  "liveStreams.period.willSplitWarning":
    "{count, plural, one {# day exceeds 9 hours} other {# days exceed 9 hours}} and will be automatically split into Part 1 and Part 2.",
  "liveStreams.period.retry": "Retry",
  "liveStreams.period.giveUp": "Give up",
  "liveStreams.period.viewDetails": "View details",
  "liveStreams.period.status.SCHEDULED": "Scheduled",
  "liveStreams.period.status.CREATED": "Created",
  "liveStreams.period.status.FAILED": "Failed",
  "liveStreams.period.status.SKIPPED": "Skipped",
  "liveStreams.period.status.ABANDONED": "Given up",
  "liveStreams.period.ownerMaxDaysExceeded": "You can schedule at most {days} days per period.",
  "liveStreams.period.billingAwaiting":
    "Waiting for every scheduled broadcast to be confirmed before releasing payment.",
  "liveStreams.period.billingConfirmed":
    "Every scheduled broadcast was confirmed — payment released.",
  "liveStreams.period.billingConfig.title": "Configure daily rate",
  "liveStreams.period.billingConfig.dailyRate": "Daily rate (R$)",
  "liveStreams.period.billingConfig.invalidRate": "Enter a value greater than zero.",
  "liveStreams.status": "Status",
  "liveStreams.nextChange": "Next change",
  "liveStreams.noUpcoming": "No upcoming changes",
  "liveStreams.livesTitle": "History",
  "liveStreams.tabUpcoming": "Upcoming",
  "liveStreams.tabPast": "Past",
  "liveStreams.noLives": "No lives found",
  "liveStreams.startsAt": "Starts:",
  "liveStreams.endsAt": "Ends:",
  "liveStreams.paymentStatusLabel": "Payment status:",
  "liveStreams.paymentColumn": "Payment",
  "liveStreams.paymentStatusPaid": "Paid",
  "liveStreams.paymentStatusPending": "Pending",
  "liveStreams.paymentStatusDirectFinance": "Direct with finance",
  "liveStreams.paymentStatusAwaitingSchedules": "Awaiting schedules",
  "liveStreams.paymentStatusUnknown": "Not informed",
  "liveStreams.refreshPaymentStatus": "Refresh payment",
  "liveStreams.paymentStatusUpdatedPaid": "Payment status updated: paid.",
  "liveStreams.paymentStatusUpdatedPending":
    "Payment status updated: still pending.",
  "liveStreams.paymentStatusUpdatedDirectFinance":
    "Payment status updated: direct with finance.",
  "liveStreams.selectLive": "Select a live to edit",
  "liveStreams.pendingTitle": "Pending Streams",
  "liveStreams.openLinkAdmin": "Open Link/Admin",
  "liveStreams.openAdmin": "Open Admin",
  "liveStreams.openDetails": "Details",
  "liveStreams.configureTitle": "Configuration",
  "liveStreams.configureSubtitle": "Customize logos, music and scoreboard",
  "liveStreams.logosTitle": "Logos",
  "liveStreams.logosDesc": "Upload and position logos on the stream",
  "liveStreams.uploadLogos": "Upload logos",
  "liveStreams.bannerTitle": "Banners",
  "liveStreams.bannerDesc": "Manage stream banners",
  "liveStreams.manageBanners": "Manage banners",
  "liveStreams.startAt": "Start",
  "liveStreams.startTime": "Start time",
  "liveStreams.endAt": "End",
  "liveStreams.endTime": "End time",
  "liveStreams.estimatedPrice": "Estimated price: {price}",
  "liveStreams.priceFormulaHint": "R$3 for the 1st hour + R$2 per extra hour, up to R$15.",
  "liveStreams.endTimeHour": "Hour",
  "liveStreams.endTimeMinute": "Minutes",
  "liveStreams.maxTwoHoursHint": "Fixed duration: 2 hours",
  "liveStreams.maxNineHoursHint":
    "The stream cannot exceed 9 hours from the start time.",
  "liveStreams.scoreType": "Scoreboard type",
  "liveStreams.selectPlaceholder": "Select...",
  "liveStreams.scoreSimple": "Simple",
  "liveStreams.scorePadel": "Padel",
  "liveStreams.scoreVolley": "Volley",
  "liveStreams.scoreCustom": "Custom",
  "liveStreams.musicTitle": "Music",
  "liveStreams.musicWithBackground": "With background music",
  "liveStreams.musicWithoutBackground": "No music",
  "liveStreams.musicPlaybackHint":
    "Songs will play in sequence and repeat until the stream ends.",
  "liveStreams.musicPreviewList": "Music preview",
  "liveStreams.musicPreviewUnavailable":
    "No songs available for preview right now.",
  "liveStreams.playlist1": "Playlist 1",
  "liveStreams.playlist2": "Playlist 2",
  "liveStreams.playlist3": "Playlist 3",
  "liveStreams.playlist4": "Playlist 4",
  "liveStreams.playlist5": "Playlist 5",
  "liveStreams.adminLink": "Admin link",
  "liveStreams.adminLinkPlaceholder": "Copy the link to access the admin panel",
  "liveStreams.advanced": "Advanced",
  "liveStreams.templateHelp": "Select a template (if available)",
  "liveStreams.template": "Template",
  "liveStreams.createAndPay": "Save",
  "liveStreams.directFinancePayment": "Direct payment in Finance",
  "liveStreams.noTemplates": "No templates available for this selection.",
  "liveStreams.noCourts": "No courts available for this selection.",
  "liveStreams.noEstablishmentsFound": "No establishments found.",
  "liveStreams.draftRestoredHint": "Continuing a schedule you had started before.",
  "liveStreams.establishmentsLoadError": "Error loading establishments. Please try again.",
  "liveStreams.disabledCreating": "Creating stream...",
  "liveStreams.disabledYoutubeNotConnected": "Connect your YouTube account first",
  "liveStreams.disabledLoading": "Loading...",
  "liveStreams.disabledPastStart": "Start date/time is in the past",
  "liveStreams.disabledTooFar": "Start date too far ahead (max 48h)",
  "liveStreams.disabledInvalidEnd": "Invalid end time (max 9h)",
  "liveStreams.disabledSelectEstablishment": "Select an establishment",
  "liveStreams.disabledSelectCamera": "Select a camera/court",
  "liveStreams.disabledSelectPlaylist": "Select a playlist",
  "liveStreams.playlistRequired": "Select a playlist.",
  "liveStreams.playlistAdminOnly":
    "Playlist can only be changed by an administrator.",
  "liveStreams.playlistLockedAfterBind":
    "The playlist cannot be changed after it is linked to this live.",
  "liveStreams.playlistMissingMapping":
    "This establishment has no playlist linked. An admin must link one in Playlists.",
  "liveStreams.noPlaylistForEstablishment":
    "No playlist linked for this establishment.",
  "liveStreams.pastStart": "You can't schedule in the past.",
  "liveStreams.startTooFar": "You can only schedule up to 48 hours in advance.",
  "liveStreams.start48hHint": "You can only schedule within the next 48 hours.",
  "liveStreams.invalidRange": "Invalid time range.",
  "liveDetails.onlyWaitingOrRunningSchedulesEditable":
    "Only waiting or in-progress broadcasts can be edited.",
  "liveDetails.scheduleNotIdentified": "Could not identify the schedule to edit.",
  "liveStreams.scheduleConflictPeriod":
    "The selected establishment and court already have a schedule within the selected time range.",
  "liveStreams.mockCreated":
    "Created a local mock schedule for testing (backend unavailable).",
  "liveStreams.minDuration": "Minimum duration: {minutes} min.",
  "liveStreams.maxDuration": "Maximum duration: {minutes} min.",

  // Live Status
  "liveStatus.waitStart": "Scheduled",
  "liveStatus.started": "Started",
  "liveStatus.finished": "Finished",
  "liveStatus.failed": "Failed",
  "liveStatus.canceled": "Canceled",

  // Live Payment
  "livePayment.title": "Payment",
  "livePayment.subtitle": "Complete payment to finish creating the stream",
  "livePayment.pending": "Pending",
  "livePayment.billedValueLabel": "Billed amount",
  "livePayment.paidAtLabel": "Payment date",
  "livePayment.paymentMethodLabel": "Payment method",
  "livePayment.back": "Back",
  "livePayment.pay": "Pay now",
  "livePayment.continue": "Continue",
  "livePayment.autoContinueToast": "Payment confirmed! Finishing the booking...",
  "livePayment.autoContinueCountdown": "Redirecting in {seconds}s...",
  "livePayment.cancelAutoContinue": "Cancel automatic redirect",
  "livePayment.paymentPendingHint":
    "Payment pending. You can open Mercado Pago to complete it.",
  "livePayment.checkingPayment": "Checking payment...",
  "livePayment.noPaymentYet": "Payment not completed yet.",
  "livePayment.paymentConfirmed": "Payment confirmed.",
  "livePayment.noPaymentRequired": "No payment required. You can continue.",
  "livePayment.hint":
    "After payment, you will be redirected to configure the stream.",
  "livePayment.fallbackName": "Stream",
  "livePayment.fallbackPlace": "Establishment",
  "livePayment.fallbackDevice": "Camera",
  "livePayment.openInNewTabHint":
    "If the payment button does not appear, use the link below to open checkout in a new tab.",
  "livePayment.openInNewTab": "Open checkout in new tab",
  "livePayment.verifyPayment": "I already paid",
  "livePayment.statusRefunded":
    "The previous payment was refunded. Please make a new payment.",
  "livePayment.statusRejected":
    "The payment was rejected. Try again or use another payment method.",
  "livePayment.statusCancelled":
    "The payment was cancelled. Please make a new payment.",
  "livePayment.statusInProcess":
    "Payment is being processed. Please wait for confirmation.",
  "livePayment.statusInMediation":
    "Payment under review. Contact Mercado Pago if you need assistance.",
  "livePayment.statusChargedBack":
    "There was a chargeback. Please make a new payment.",

  // Live Link
  "liveLink.title": "Live Stream",
  "liveLink.subtitle": "Admin link to configure the stream",
  "liveLink.adminLinkTitle": "Admin link",
  "liveLink.adminLinkPlaceholder":
    "Link will be available after creating the stream",
  "liveLink.adminLinkHint":
    "Use this link to open the admin panel and configure logos, music and scoreboard.",
  "liveLink.openNarratorPanel": "Open admin panel",

  "liveBranding.schedulingTitle": "Setting up stream",
  "liveBranding.schedulingBody":
    "We are preparing video, logos, and camera connection. This may take a few seconds.",
  "liveBranding.ownerPaymentTitle": "Confirmation",
  "liveBranding.ownerPaymentConfirm": "Confirm",
  "liveBranding.ownerPaymentConfirmed":
    "Request sent. Our team will contact you to process the charge.",

  // Live Admin
  "liveAdmin.title": "Live Admin",
  "liveAdmin.subtitle": "Manage scoreboard, banners, logos and music",
  "liveAdmin.subtitleWithLive": "{name} · {device} · {start} → {end}",
  "liveAdmin.openYoutube": "Open on YouTube",
  "liveAdmin.scoreTitle": "Scoreboard",
  "liveAdmin.team1": "Team 1",
  "liveAdmin.team2": "Team 2",
  "liveAdmin.bannersTitle": "Banners",
  "liveAdmin.bannersSubtitle": "Select a banner to show on the stream",
  "liveAdmin.loopingMode": "Auto-rotate mode",
  "liveAdmin.on": "On",
  "liveAdmin.off": "Off",
  "liveAdmin.narrationTitle": "Narration",
  "liveAdmin.micStatus": "Mic: {status}",
  "liveAdmin.toggleMic": "Toggle mic",
  "liveAdmin.startNarration": "Start narration",
  "liveAdmin.stopNarration": "Stop narration",
  "liveAdmin.narrationHint": "Narration is a placeholder for now.",
  "liveAdmin.logosTitle": "Logos",
  "liveAdmin.onboardingHint": "1. Upload your logo in the library on the right → 2. Drag it to the desired position on the board above → 3. Click \"Save\".",
  "liveAdmin.musicSectionTitle": "Background music",
  "liveAdmin.unsavedChanges": "Unsaved changes",
  "liveAdmin.selectLogo": "Select logo to edit",
  "liveAdmin.addLogo": "Add logo",
  "liveAdmin.newLogo": "New logo…",
  "liveAdmin.deleteLogo": "Remove logo",
  "liveAdmin.addLogoTitle": "Add logo",
  "liveAdmin.add": "Add",
  "liveAdmin.cancel": "Cancel",
  "liveAdmin.image": "Image",
  "liveAdmin.searchImage": "Search image…",
  "liveAdmin.searchPlaylist": "Search playlist…",
  "liveAdmin.position": "Position",
  "liveAdmin.position.TOP_LEFT": "Top left",
  "liveAdmin.position.TOP_RIGHT": "Top right",
  "liveAdmin.position.BOT_LEFT": "Bottom left",
  "liveAdmin.position.BOT_RIGHT": "Bottom right",
  "liveAdmin.offsetX": "Offset X",
  "liveAdmin.offsetY": "Offset Y",
  "liveAdmin.saveLogo": "Save logo",
  "liveAdmin.saveAllLogos": "Save",
  "liveAdmin.saveLogosConfirmTitle": "Save logos?",
  "liveAdmin.saveLogosConfirmBody":
    "You changed logo settings. Do you want to save them before saving the playlist?",
  "liveAdmin.continueWithoutSavingLogos": "Save playlist without saving logos",
  "liveAdmin.saveLogosAndContinue": "Save logos and save playlist",
  "liveAdmin.emptyLogoError":
    "Select an image or remove the empty logo before saving.",
  "liveAdmin.reservedArea": "Reserved area (ads)",
  "liveAdmin.cameraView": "Camera View",
  "liveAdmin.dragHint":
    "Tip: drag the logo to adjust its position in the video. You can also increase or decrease the logo size.",
  "liveAdmin.musicTitle": "Music",
  "liveAdmin.playlist": "Playlist",
  "liveAdmin.savePlaylist": "Save playlist",
  "liveAdmin.uploadLogoMedia": "Upload media for logo",

  // Live Playlists
  "livePlaylists.title": "Playlists",
  "livePlaylists.add": "New playlist",
  "livePlaylists.establishment": "Establishment",
  "livePlaylists.id": "ID",
  "livePlaylists.name": "Name",
  "livePlaylists.youtubeId": "YouTube ID",
  "livePlaylists.youtubeHint":
    "Leave blank to create on YouTube automatically.",
  "livePlaylists.youtubeAccountId": "YouTube account",
  "livePlaylists.youtubeAccountIdHint": "Choose the account that will own this playlist on YouTube.",
  "livePlaylists.filterYoutubeAccount": "Filter by YouTube account",
  "livePlaylists.youtubeAccountColumn": "YouTube account",
  "livePlaylists.actions": "Actions",
  "livePlaylists.empty": "No playlists found.",
  "livePlaylists.createTitle": "Create playlist",
  "livePlaylists.editTitle": "Edit playlist",
  "livePlaylists.save": "Save",
  "livePlaylists.cancel": "Cancel",

  // Live Media Library
  "liveMedia.title": "Media",
  "liveMedia.upload": "Upload media",
  "liveMedia.empty": "No media found.",

  // Live Details
  // Live Workspace
  "liveWorkspace.tabs.detalhes": "Details",
  "liveWorkspace.tabs.pagamento": "Payment",
  "liveWorkspace.tabs.branding": "Logos/Music",
  "liveWorkspace.tabs.placar": "Scoreboard",
  "liveWorkspace.comingSoon": "Coming soon in this tab.",

  "liveDetails.title": "Stream Details",
  "liveDetails.scoreboardButton": "Scoreboard",
  "liveDetails.back": "Back",
  "liveDetails.openBranding": "Logos/Music",
  "liveDetails.payRequiredToConfigure":
    "Pay the stream to access logos and configure.",
  "liveDetails.scheduleChangeDuringStreamHint": "Schedule changes made while the stream is live may require a restart to take effect immediately.",
  "liveDetails.restartDialogTitle": "Change during broadcast",
  "liveDetails.restartDialogBody": "For the changes to take effect during the broadcast, a restart will be required. Restart now or later?",
  "liveDetails.restartLater": "Restart later",
  "liveDetails.restartNow": "Restart now",
  "liveDetails.tabs.overview": "Overview",
  "liveDetails.tabs.schedules": "Schedules",
  "liveDetails.tabs.emails": "Emails",
  "liveDetails.tabs.service": "Service",
  "liveDetails.name": "Name",
  "liveDetails.privacy": "Privacy",
  "liveDetails.privacyPublic": "Public",
  "liveDetails.privacyUnlisted": "Unlisted",
  "liveDetails.privacyPrivate": "Private",
  "liveDetails.privacyPublicHint": "Anyone can find and watch this broadcast.",
  "liveDetails.privacyUnlistedHint": "Only people with the link can watch; it won't appear in search.",
  "liveDetails.privacyPrivateHint": "Only people you authorize can watch.",
  "liveDetails.enableAudio": "Enable audio",
  "liveDetails.backgroundMusic": "Background music",
  "liveDetails.yes": "Yes",
  "liveDetails.no": "No",
  "liveDetails.save": "Save",
  "liveDetails.saveConfig": "Save",
  "liveDetails.discardChanges": "Discard changes",
  "liveDetails.status": "Status",
  "liveDetails.playlist": "Playlist",
  "liveDetails.youtubeKeyId": "YouTube key ID",
  "liveDetails.youtubeKey": "YouTube key",
  "liveDetails.dropletId": "Droplet ID",
  "liveDetails.paid": "Paid",
  "liveDetails.device": "Local/Device",
  "liveDetails.paymentPreference": "Payment preference",
  "liveDetails.billedValue": "Billed value",
  "liveDetails.paidLastStatus": "Last payment status",
  "liveDetails.initiatedByEmail": "Started by (email)",
  "liveDetails.initiatedByRole": "Started by (role)",
  "liveDetails.schedulesTitle": "Schedules",
  "liveDetails.addSchedule": "Add schedule",
  "liveDetails.editSchedule": "Edit schedule",
  "liveDetails.scheduleStartedDateLocked": "This broadcast is already live — only the description can be changed.",
  "liveDetails.appendDescription": "Description",
  "liveDetails.startAt": "Start",
  "liveDetails.endAt": "End",
  "liveDetails.cancel": "Cancel",
  "liveDetails.create": "Create",
  "liveDetails.edit": "Edit",
  "liveDetails.delete": "Delete",
  "liveDetails.deleteScheduleTitle": "Delete schedule",
  "liveDetails.deleteScheduleMessage": "Are you sure you want to delete this broadcast schedule? This action cannot be undone.",
  "liveDetails.deleteScheduleMessageStarted":
    "This broadcast is already live. Deleting this schedule cancels the broadcast on YouTube right now. This action cannot be undone.",
  "liveDetails.deleteLive": "Delete live",
  "liveDetails.deleteLiveTitle": "Delete live",
  "liveDetails.deleteLiveMessage": "Are you sure you want to delete this live and all of its schedules? This action cannot be undone.",
  "liveDetails.noSchedules": "No schedules found.",
  "liveDetails.scheduleStatus": "Status",
  "liveDetails.emailsTitle": "Emails",
  "liveDetails.email": "Email",
  "liveDetails.add": "Add",
  "liveDetails.remove": "Remove",
  "liveDetails.noEmails": "No emails found.",
  "liveDetails.serviceTitle": "Service",
  "liveDetails.toggleDroplet": "Start/Stop service",
  "liveDetails.restartService": "Restart service",
  "liveDetails.viewLogs": "View logs",
  "liveDetails.logsTitle": "Logs",
  "liveDetails.close": "Close",
  "liveDetails.adminOnlyService":
    "Only administrators can start/restart the service and view logs.",

  "liveService.title": "Start stream",
  "liveService.startStream": "Start stream",
  "liveService.stopStream": "Finish stream",
  "liveService.autoLogs": "Auto-refresh logs",
  "liveService.autoLogsHint": "refreshing…",
  "liveService.logsPlaceholder": "No logs yet.",
  "liveService.logsNotAvailable":
    "Logs unavailable for this service (droplet not found).",
  "liveService.starting": "Starting stream…",
  "liveService.stopping": "Stopping stream…",
  "liveService.restarting": "Restarting service…",
  "liveService.refreshFailed": "Action applied, but the status on screen could not be refreshed. Please reload the page.",
  "liveService.brandingSavedRestartFailed": "Settings saved, but the broadcast could not be restarted to apply them now. Restart it manually if needed.",
  "liveService.notStarted":
    "Service didn't start. Check backend (droplet/logs).",
  "liveService.finishedHint":
    "Stream finished. To start again, create a new stream.",

  // Live Scoreboard
  "liveScoreboard.pageTitle": "Live scoreboard",
  "liveScoreboard.pageSubtitle": "Scoreboard frontend for live operation.",
  "liveScoreboard.liveFallback": "Live scoreboard",
  "liveScoreboard.liveFallbackWithId": "Stream #{id}",
  "liveScoreboard.simpleFlowHint":
    "Scoreboard settings synced with the stream transmission.",
  "liveScoreboard.saveSuccess": "Scoreboard settings saved.",
  "liveScoreboard.saveWarning":
    "Could not save to backend right now. Preference applied locally.",
  "liveScoreboard.emptyNamesError": "Fill in the scoreboard names before saving.",
  "liveScoreboard.saveBeforeGenerateLinkWarning":
    "Could not save scoreboard settings before generating the admin link.",
  "liveScoreboard.logoFallback": "Logo",
  "liveScoreboard.overlayName": "Scoreboard",
  "liveScoreboard.defaultLogoName": "Meu Lance",
  "liveScoreboard.overlay.teamA": "• TEAM A",
  "liveScoreboard.overlay.teamB": "TEAM B",
  "liveScoreboard.overlay.pointHeader": "POINTS",
  "liveScoreboard.overlay.primaryHeader": "GAMES",
  "liveScoreboard.overlay.scoreHeader": "SCORE",
  "liveScoreboard.overlay.pointShort": "PTS",
  "liveScoreboard.overlay.setShort": "SETS",
  "liveScoreboard.configTag": "SCHEDULING / CONFIGURATION",
  "liveScoreboard.configTitle": "Enable scoreboard on stream",
  "liveScoreboard.configDescription":
    "When creating the live, the club owner chooses the sport. After that, the system automatically generates the admin link to operate the live scoreboard.",
  "liveScoreboard.broadcastLabel": "Scoreboard on stream",
  "liveScoreboard.enabled": "Enabled",
  "liveScoreboard.disabled": "Disabled",
  "liveScoreboard.toggleLabel": "Include scoreboard in camera view",
  "liveScoreboard.musicToggleLabel": "Include background music in stream",
  "liveScoreboard.savingHint": "Saving scoreboard preference...",
  "liveScoreboard.sportTypeLabel": "Scoreboard sport",
  "liveScoreboard.sport.football": "Football",
  "liveScoreboard.sport.padel": "Padel",
  "liveScoreboard.sport.beachTennis": "Beach Tennis",
  "liveScoreboard.generateAdminLink": "Generate admin link",
  "liveScoreboard.adminLinkLabel": "Admin link",
  "liveScoreboard.adminTag": "ADMIN / {sport}",
  "liveScoreboard.adminPanelTitle": "Scoreboard panel",
  "liveScoreboard.adminFootballDescription":
    "The club staff opens the link and controls everything with plus and minus buttons only.",
  "liveScoreboard.adminPadelDescription":
    "It also works with only plus and minus. The system understands point progression automatically.",
  "liveScoreboard.adminBeachDescription":
    "Same behavior as padel, keeping operation simple and fast during the stream.",
  "liveScoreboard.enableToEdit":
    "Enable the scoreboard on stream to unlock editing.",
  "liveScoreboard.team1Upper": "TEAM 1",
  "liveScoreboard.team2Upper": "TEAM 2",
  "liveScoreboard.teamA": "Team A",
  "liveScoreboard.teamB": "Team B",
  "liveScoreboard.matchTime": "Match time",
  "liveScoreboard.liveNow": "Live",
  "liveScoreboard.matchTimeLive": "{time} ({status})",
  "liveScoreboard.pair1Upper": "PAIR 1",
  "liveScoreboard.pair2Upper": "PAIR 2",
  "liveScoreboard.games": "Games",
  "liveScoreboard.sets": "Sets",
  "liveScoreboard.currentPoint": "Current point",
  "liveScoreboard.ruleHintPadel":
    "Rule example: if it is at 15 and you press plus, it goes to 30. Pressing plus again goes to 40.",
  "liveScoreboard.youtubeTitle": "YouTube view - {sport}",
  "liveScoreboard.setLabel": "SET {set}",
  "liveScoreboard.summaryLine":
    "Sets: {setsA} x {setsB} | Point: {pointA} x {pointB}",
  "liveScoreboard.adminLinkSaved": "Admin link settings saved successfully.",
  "liveScoreboard.adminLinkWarning":
    "This link will be used by third parties without platform access. Share the link and access code only with the person who will operate this match scoreboard.",
  "liveScoreboard.adminAccessCodeLabel": "Access code",
  "liveScoreboard.adminAccessCodeNotRecoverable":
    "The code cannot be shown again. Generate a new link to set another code.",
  "liveScoreboard.adminAccessCodeHelp":
    "Up to 8 characters (letters and numbers). Leave empty to generate automatically.",
  "liveScoreboard.generateRandomCode": "Generate random code",
  "liveScoreboard.adminLinkModalTitle": "Configure admin link",
  "liveScoreboard.saveAdminLinkConfig": "Save admin link settings",
  "liveScoreboard.adminLinkExpirationLabel": "Link expiration",
  "liveScoreboard.adminLinkExpirationFallback": "Expires 5 minutes after the stream ends.",
  "liveScoreboard.adminLinkExpirationValue": "Link expiration: {dateTime}",
  "liveScoreboard.public.accessCodeLabel": "Access code",
  "liveScoreboard.public.accessCodeHelp": "Enter the access code received with the link.",
  "liveScoreboard.public.unlock": "Access scoreboard",
  "liveScoreboard.public.operatorTag": "SCOREBOARD OPERATOR",
  "liveScoreboard.public.liveFallback": "Live scoreboard",
  "liveScoreboard.public.invalidLink": "Invalid link. Check the access code.",
  "liveScoreboard.public.disabledForLive": "Scoreboard disabled for this stream.",
  "liveScoreboard.public.expired":
    "This stream has already ended. This link has expired and public scoreboard access ends 5 minutes after the stream ends.",
  "liveScoreboard.public.accessDenied":
    "Access denied. The scoreboard is disabled or the code is invalid.",
  "liveScoreboard.public.accessUnavailable":
    "Unable to access this scoreboard with the provided information.",
  "liveScoreboard.public.saveRetryable":
    "Could not save right now. Please try again.",
  "liveScoreboard.public.notFound": "Operator link not found.",
  "liveScoreboard.public.loadError": "Could not load this scoreboard right now.",
  "liveScoreboard.public.expiredSave": "Link expired. This scoreboard can no longer be updated.",

  "notifications.title": "Notifications",
  "notifications.noIssues": "No issues found",
  "notifications.issueItem": "{establishment}: {device} - {reasons}",
  "notifications.reason.OFFLINE": "Camera offline",
  "notifications.reason.SD_CARD_ERROR": "SD card error",
  "notifications.reason.BUTTON_SHORT_CIRCUIT": "Button short circuit",

  "metricChart.channel": "Camera",
  "metricChart.total": "Total",
  "metricChart.grandTotal": "Grand Total",
  "metricChart.loadError": "Error loading metrics",
  "metricChart.errorState": "Could not load metrics right now. Please try again shortly.",
  "metricChart.showAll": "Show all (+{count})",
  "metricChart.showLess": "Show less",
  "metricChart.noData": "No data found.",
  "metricChart.metricsOmitted":
    "{count} metrics omitted. Refine filters to view specific data.",

  // Analytics Reporter (legacy)
  "analyticsReporter.title": "Analytics Report",
  "analyticsReporter.startDate": "Start Date",
  "analyticsReporter.endDate": "End Date",
  "analyticsReporter.search": "Search establishment",
  "analyticsReporter.eventType": "Event Type",
  "analyticsReporter.generate": "Generate Report",
  "analyticsReporter.total": "Total",
  "analyticsReporter.establishment": "Establishment",
  "analyticsReporter.action": "Action",
  "analyticsReporter.count": "Count",
  "analyticsReporter.errorMaxDays": "The date range cannot exceed {maxDays} days.",
  "analyticsReporter.loading": "Loading...",
  "analyticsReporter.noData": "No data found.",
  "analyticsReporter.generating": "Generating report...",
  "analyticsReporter.errorFetch": "Error fetching report.",

  "analyticsV2.title": "Reports",
  "analyticsV2.startDate": "Start Date",
  "analyticsV2.endDate": "End Date",
  "analyticsV2.metric": "Metric",
  "analyticsV2.format": "Format",
  "analyticsV2.table": "Table",
  "analyticsV2.chart": "Chart",
  "analyticsV2.granularity": "Granularity",
  "analyticsV2.daily": "Daily",
  "analyticsV2.monthly": "Monthly",
  "analyticsV2.total": "Total",
  "analyticsV2.groupBy": "Group by:",
  "analyticsV2.court": "Court",
  "analyticsV2.all": "All",
  "analyticsV2.generateReport": "Generate Report",
  "analyticsV2.totalEvents": "Total events: {total}",
  "analyticsV2.chartNotAvailable":
    "Chart not available for Total granularity. Use Table format.",
  "analyticsV2.establishment": "Establishment",
  "analyticsV2.event": "Event",
  "analyticsV2.quantity": "Quantity",
  "analyticsV2.date": "Date",
  "analyticsV2.noDataFound": "No data found.",
  "analyticsV2.selectMetric": "Select a metric",
  "analyticsV2.selectEstablishment": "Select at least one establishment",
  "analyticsV2.reportError": "Error generating report",
  "analyticsV2.download": "Download CSV",
  "analyticsV2.downloadError": "Error downloading report",
  "analyticsV2.reportTitle": "Report - {metric}",
  "analyticsV2.period": "Period: {start} ~ {end}",
  "analyticsV2.description": "Description",
  "analyticsV2.channel": "Channel",

  "metrics.custom_downloaded_video_2": "Video download",
  "metrics.custom_played_video_2": "Video view",
  "metrics.video_statistics": "Video statistics",
  "metrics.custom_whatsapp_opening": "WhatsApp opening",
  "metrics.scroll": "Scroll",
  "metrics.custom_played_live": "Live view",
  "metrics.custom_sponsor_banner": "Sponsor banner",
  "metrics.custom_prospectpro_banner": "Sponsor banner",
  "metrics.custom_prospectpro_popup": "Sponsor popup",
  "metrics.custom_deixacomochef_banner": "Deixa Com o Chef banner",
  "metrics.custom_deixacomochef_popup": "Deixa Com o Chef popup",
  "metrics.page_view": "Page view",
  "metrics.custom_instagram_opening": "Instagram opening",
  "metrics.click": "Click",
  "metrics.session_start": "Session start",
  "metrics.first_visit": "First visit",
  "metrics.user_engagement": "User engagement",
  "metrics.file_download": "File download",

  // Subscriptions Dashboard
  "subscriptions.title": "Subscriptions",
  "subscriptions.activeSubscriptions": "Active Subscriptions",
  "subscriptions.cancelledSubscriptions": "Cancelled Subscriptions",
  "subscriptions.expiredSubscriptions": "Expired Subscriptions",
  "subscriptions.singlePurchases": "Single Purchases",
  "subscriptions.subscriptionRevenueCollected": "Collected Revenue (Subscriptions)",
  "subscriptions.subscriptionRevenueTrial": "In Trial (projected, not collected)",
  "subscriptions.singleRevenue": "Single Purchase Revenue",
  "subscriptions.totalRevenue": "Total Collected Revenue",
  "subscriptions.noRecords": "No records found.",
  "subscriptions.searchPlaceholder": "Search by name or email...",
  "subscriptions.filterType": "Type",
  "subscriptions.filterStatus": "Status",
  "subscriptions.filterOffering": "Product",
  "subscriptions.filterStartDate": "Start Date",
  "subscriptions.filterEndDate": "End Date",
  "subscriptions.columnName": "Name",
  "subscriptions.columnEmail": "Email",
  "subscriptions.columnType": "Type",
  "subscriptions.columnOffering": "Product",
  "subscriptions.columnAmount": "Amount",
  "subscriptions.columnStatus": "Status",
  "subscriptions.columnDate": "Date",
  "subscriptions.columnNextBilling": "Next Billing",
  "subscriptions.columnCancellation": "Cancellation Date",
  "subscriptions.columnGatewayId": "Gateway ID",
  "subscriptions.rowsPerPage": "Rows per page",
  "subscriptions.metricsExcludeTestNote": "The numbers below do not include subscriptions marked as test. \"In trial\" values have not been collected yet.",
  "subscriptions.metricsCounts": "Counts",
  "subscriptions.metricsRevenue": "Revenue",
  "subscriptions.filterIncludeTest": "Show test",
  "subscriptions.hiddenTestCount": "{count} test subscription(s) hidden from the numbers and list.",
  "subscriptions.filterBillingPhase": "Phase",
  "subscriptions.billingPhase.trial": "In trial",
  "subscriptions.billingPhase.active": "Billing",
  "subscriptions.testChip": "Test",
  "subscriptions.trialChip": "In trial",

  "subscriptionDetail.title": "Transaction Details",
  "subscriptionDetail.visitorInfo": "Visitor Information",
  "subscriptionDetail.phone": "Phone",
  "subscriptionDetail.transactionData": "Transaction Data",
  "subscriptionDetail.type": "Type",
  "subscriptionDetail.product": "Product",
  "subscriptionDetail.cycle": "Cycle",
  "subscriptionDetail.value": "Amount",
  "subscriptionDetail.purchaseDate": "Purchase Date",
  "subscriptionDetail.nextBilling": "Next Billing",
  "subscriptionDetail.cancellation": "Cancellation",
  "subscriptionDetail.technicalDetails": "Technical Details",
  "subscriptionDetail.internalTransactionId": "Transaction ID (internal)",
  "subscriptionDetail.externalId": "External ID (MP)",
  "subscriptionDetail.gatewayPaymentId": "Gateway Payment ID",
  "subscriptionDetail.subscriptionExternalId": "Subscription External ID",
  "subscriptionDetail.historyTitle": "Visitor Transaction History",
  "subscriptionDetail.noDataFound": "No data found for this transaction.",
  "subscriptionDetail.type.subscription": "Subscription",
  "subscriptionDetail.type.singlePurchase": "One-time",
  "subscriptionDetail.cycle.monthly": "Monthly",
  "subscriptionDetail.cycle.annual": "Annual",
  "subscriptionDetail.status.approved": "Approved",
  "subscriptionDetail.status.pending": "Pending",
  "subscriptionDetail.status.rejected": "Rejected",
  "subscriptionDetail.status.cancelled": "Cancelled",
  "subscriptionDetail.status.superseded": "Superseded",
  "subscriptionDetail.testChip": "Test subscription",
  "subscriptionDetail.trialChip": "In trial period",
  "subscriptionDetail.markAsTest": "Mark as test",
  "subscriptionDetail.unmarkAsTest": "Remove test flag",
  "subscriptionDetail.testMarkedBy": "Marked as test by {name} on {date}",
  "subscriptionDetail.testFlagUpdateSuccess": "Test flag updated.",
  "subscriptionDetail.testFlagUpdateError": "Could not update the test flag.",
  // Audit Logs
  "auditLogs.title": "Audit",
  "auditLogs.tabActivities": "Activities",
  "auditLogs.tabRequests": "Requests",
  "auditLogs.when": "When",
  "auditLogs.who": "Who",
  "auditLogs.what": "What they did",
  "auditLogs.entity": "Entity",
  "auditLogs.entityId": "ID",
  "auditLogs.method": "Method",
  "auditLogs.route": "Route",
  "auditLogs.statusCode": "Status",
  "auditLogs.duration": "Duration",
  "auditLogs.filterUser": "Who",
  "auditLogs.filterCategory": "Category",
  "auditLogs.filterAction": "Action",
  "auditLogs.filterDateFrom": "From",
  "auditLogs.filterDateTo": "To",
  "auditLogs.filterButton": "Filter",
  "auditLogs.placeholderEmail": "User email",
  "auditLogs.empty": "No records found",
  "auditLogs.selectCategoryFirst": "Select a category first",
  "auditLogs.allActions": "All actions",
  "auditLogs.sessionExpired": "Session expired. Please log in again.",
  "logoModels.title": "My logo models",
  "logoModels.subtitle": "Logo model sets saved for this establishment",
  "logoModels.empty": "No models saved yet",
  "logoModels.noEstablishment": "Establishment not identified in this stream",
  "logoModels.saveAsModel": "Save as model",
  "logoModels.saveAsModelTitle": "Save as model",
  "logoModels.nameLabel": "Model name",
  "logoModels.nameRequired": "Enter a name",
  "logoModels.logosRequired": "Add at least one logo before saving as model",
  "logoModels.created": "Model created",
  "logoModels.updated": "Model updated",
  "logoModels.deleted": "Model deleted",
  "logoModels.createTitle": "New model",
  "logoModels.renameTitle": "Rename model",
  "logoModels.createHint": "The model will be created with the logos configured in this stream.",
  "logoModels.apply": "Apply",
  "logoModels.rename": "Rename",
  "logoModels.delete": "Delete",
  "logoModels.deleteTitle": "Delete model?",
  "logoModels.deleteConfirm": "Are you sure you want to delete the model \"{name}\"? Logos on the stream will not be changed.",
  "logoModels.applied": "Logo model applied",
  "logoModels.logoCount": "{count, plural, one {# logo} other {# logos}}",
  "logoModels.newModel": "New model",
  "logoModels.suggestTitle": "Reuse logos",
  "logoModels.suggestBody": "The last model used in this venue was \"{name}\". Would you like to reuse it?",
  "logoModels.suggestReuse": "Reuse",
  "logoModels.suggestChooseOther": "Choose another",
  "logoModels.suggestSetupManually": "Set up manually",
};
